import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { KeywordAvgCreationDTO } from "app/pages/activation/types/api";

export const KEYWORDS_AVG_QUERY_KEY = "KEYWORDS_AVG_QUERY_KEY";

export const useGetKeywordsAvgQuery = (data?: KeywordAvgCreationDTO | null) => {
    return useQuery({
        queryKey: [KEYWORDS_AVG_QUERY_KEY, data?.campaignguid],
        queryFn: async () => {
            const { rankTracker } = createActivationApi();

            return await rankTracker.getKeywordsAvg(data);
        },
        enabled: !!data,
        refetchOnWindowFocus: false,
        retry: 1,
    });
};
